import { CloseOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import React from 'react';
import { BaseButton } from '../UI/BaseButton';

interface UnsavedChangesModalProps {
  open: boolean;
  onDiscard: () => void;
  onCancel: () => void;
  onSave: () => void;
  isSaving?: boolean;
  message?: string;
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  open,
  onDiscard,
  onCancel,
  onSave,
  isSaving = false,
  message = "You haven't saved your description yet. How would you like to proceed?",
}) => {
  return (
    <Modal
      title=""
      open={open}
      onCancel={onCancel}
      centered
      width={640}
      closeIcon={<CloseOutlined style={{ fontSize: 16 }} />}
      footer={
        <div className="flex items-center justify-between w-full">
          <div className="flex gap-3">
            <BaseButton type="primary" danger size="large" onClick={onDiscard}>
              Discard and Exit
            </BaseButton>
          </div>
          <div className="flex gap-3 items-center">
            <BaseButton type="secondary" size="large" onClick={onCancel}>
              Cancel
            </BaseButton>
            <BaseButton type="primary" size="large" onClick={onSave} disabled={isSaving}>
              Save and Exit
            </BaseButton>
          </div>
        </div>
      }
      styles={{
        header: { padding: '20px 32px' },
        body: { padding: '20px 32px' },
        footer: { padding: '12px', paddingBottom: '0px', marginTop: 0 },
      }}
    >
      <div className="text-base font-semibold text-brand-grey-dark leading-6">{message}</div>
    </Modal>
  );
};
